<template>
  <div>
    <CommonHeader :page="'Paramètrage produit'" />

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <SPs title=""></SPs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SPs from "./Tables/SPs";
import CommonHeader from "@/components/CommonHeader";
export default {
  name: "sptables",
  components: {
    SPs,
    CommonHeader,
  },
};
</script>
<style></style>
